export const CyCrewManagementDialog = {
  NameInput: "CrewManagementDialogNameInput",
  IsPrivateCheckbox: "CrewManagementDialogIsPrivateCheckbox",
  SaveButton: "CrewManagementDialogSaveButton",
} as const;
